"use strict";

module.exports = {
    "user2": {
        "add-account": "Add account",
        "edit-accounts": "Edit accounts",
        "enter": "Log in",
        "exit": "Log out",
        "help": "Help",
        "mail": ["new message", "new messages", "", ""],
        "mail_compose": "Compose message",
        "passport": "Account management",
        "settings": "Settings",
        "upload_files": "My Disk"
    }
};